import {Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {NgxSmartModalService} from 'ngx-smart-modal';
import {requiredFieldValidator} from '../../validators/required-field-validator.directive';
import {whitelistCharacterValidator} from '../../validators/valid-character-validator.directive';

@Component({
  selector: 'common-smart-modal',
  templateUrl: './common-smart-modal.component.html',
  styleUrls: ['./common-smart-modal.component.scss']
})
export class CommonSmartModalComponent implements OnInit, OnChanges {
  @Input()
  dynamicID: string;

  @Input()
  contentHeader: string;

  @Input()
  content: string;

  @Input()
  closeButtonText: string;

  @Input()
  acceptButtonText: string;

  @Input()
  placeholder: string = 'Reason (Mandatory)';

  @Input()
  textFieldMode: boolean = false;

  @Input()
  value: string;

  @Output()
  proceed = new EventEmitter<boolean>();

  @Output()
  proceedWithComment = new EventEmitter<string>();

  @Output()
  modalClosed = new EventEmitter<string>();

  @Input()
  commentMode: boolean;

  @Input()
  type: string;

  @Input()
  required: boolean = true;

  @Input()
  editable: boolean = true;

  @Input()
  hasAcceptButton: boolean = true;

  commentForm: FormGroup;

  get comment(): FormControl {
    const inputName = this.textFieldMode ? 'commentInput' : 'comment';
    return this.commentForm.get(inputName) as FormControl;
  }

  constructor(private formBuilder: FormBuilder, private ngxSmartModalService: NgxSmartModalService) {
  }

  ngOnInit(): void {
    this.createForm();
  }

  private createForm() {
    const value = this.editable ? this.value : {value: this.value, disabled: true};
    const validation = this.required ? [requiredFieldValidator, whitelistCharacterValidator] : [];
    this.commentForm = this.formBuilder.group({
      comment: new FormControl(value, this.textFieldMode ? [] : validation),
      commentInput: new FormControl(value, this.textFieldMode ? validation : []),
    });
    this.commentForm.updateValueAndValidity();
  }


  proceedClicked() {
    this.proceed.emit(true);
  }

  recordComment() {
    const comment = this.textFieldMode ? this.commentForm.getRawValue().commentInput : this.commentForm.getRawValue().comment;
    this.proceedWithComment.emit(comment);
    this.createForm();
  }

  closeModal() {
    this.ngxSmartModalService.close(this.dynamicID);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.value && this.commentForm) {
      this.value = changes.value.currentValue;
      this.commentForm.get('comment').patchValue(this.value);
      this.commentForm.get('commentInput').patchValue(this.value);
    }
  }
}
